import { createAction } from "@reduxjs/toolkit";
import { ucEndpoints } from "../../config/config";
import {
  getRegionSettingsPerUserFailure,
  getRegionSettingsPerUserSuccess,
  startGetRegionSettingsPerUser
} from "../../store/regionSettingsPerUser";
import { apiCallBegan } from "../middlwares/api";
import * as actionTypes from "./actionTypes";

export const getRegionSettingsPerUser = () => dispatch => {
  dispatch(
    apiCallBegan({
      url: `${ucEndpoints.selectedRegionSettingsPerUser}`,
      method: "get",
      onStart: startGetRegionSettingsPerUser,
      onSuccess: getRegionSettingsPerUserSuccess,
      onFailure: getRegionSettingsPerUserFailure
    })
  );
};

export const startUpdateRegionSettingsPerUser = createAction(
  actionTypes.START_UPDATE_REGION_SETTINGS_PER_USER
);

export const updateRegionSettingsPerUserSuccess = createAction(
  actionTypes.UPDATE_REGION_SETTINGS_PER_USER_SUCCESS
);

export const updateRegionSettingsPerUserFailure = createAction(
  actionTypes.UPDATE_REGION_SETTINGS_PER_USER_FAILED
);

export const updateRegionSettingsPerUser = values => dispatch => {
  const requestBodyParameters = {
    ...{
      measurementSystemId: null,
      shortDateFormatId: null,
      longDateFormatId: null,
      shortTimeFormatId: null,
      longTimeFormatId: null,
      timeZoneId: null
    },
    ...values
  };
  return dispatch(
    apiCallBegan({
      url: `${ucEndpoints.selectedRegionSettingsPerUser}`,
      method: "put",
      data: requestBodyParameters,
      onStart: startUpdateRegionSettingsPerUser,
      onSuccess: () => dispatch => {
        dispatch(updateRegionSettingsPerUserSuccess());
        dispatch(getRegionSettingsPerUser());
      },
      onSuccessMessage: "Personal region settings successfully saved!",
      onFailureMessage: "An error occurred while saving personal region settings",
      onFailure: updateRegionSettingsPerUserFailure
    })
  );
};
